import { useSessionStorage } from "@uidotdev/usehooks";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
//@ts-ignore
import Card from "../Reusable/Card";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/EndPoint";
import { IFilterManifest } from "../../types/interface";
import { hasValues } from "../../utils/hasValues";
import ManifestFilter from "../ManifestFilter";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import { classNames } from "../Reusable/DatePicker/helpers";

const ManifestList = (props: any) => {
  const { defaultBranch, ConsignmentData } = props;
  const navigate = useNavigate();
  const [searchParams, setSearchParms] = useSearchParams();
  const [localState, handleSetState] = useSessionStorage<IFilterManifest>(
    "dispatch-manifest-filter",
    {
      created__range: null,
      vehicle: null,
      driver: null,
      destination_branch: null,
    }
  );
  const [active, setActive] = useState("");
  const [isFilterVisible, setFilterVisiable] = useState(hasValues(localState));
  const { setValue, getValues, watch, reset, control } =
    useForm<IFilterManifest>({
      defaultValues: async (payload) => ({
        created__range: localState?.created__range ?? null,
        vehicle: localState?.vehicle ?? null,
        driver: localState?.driver ?? null,
        destination_branch: localState?.destination_branch ?? null,
      }),
    });

  const handleFilterReset = () => {
    reset({
      created__range: null,
      vehicle: null,
      driver: null,
      destination_branch: null,
    });
  };

  const checkedAllItems = searchParams.get("selectAllItems") === "1";
  const handleIndividualSelect = (value: string) => {
    let selectedItems = searchParams.get("selectedItems")?.split(",");
    if (!selectedItems || selectedItems === undefined) {
      searchParams.set("selectedItems", value);
      setSearchParms(searchParams);
      return;
    }
    let itemIndex = selectedItems?.findIndex((item) => item === value);
    if (itemIndex > -1) {
      selectedItems.splice(itemIndex, 1);
      const newSelectedItems = selectedItems
        ?.map((item) => item)
        .join(",")
        .toString();
      if (newSelectedItems.length) {
        searchParams.set("selectedItems", newSelectedItems);
      } else {
        searchParams.delete("selectedItems");
      }
      searchParams.set("selectAllItems", "0");
      setSearchParms(searchParams);
    } else {
      selectedItems?.push(value);
      const newSelectedItems = selectedItems
        ?.map((item) => item)
        .join(",")
        .toString();
      searchParams.set("selectedItems", newSelectedItems);
      setSearchParms(searchParams);
    }
  };

  const isSelected = (value: string) => {
    const selectedItems = searchParams.get("selectedItems")?.split(",");
    if (!selectedItems) {
      return false;
    }
    return selectedItems.includes(value);
  };

  const handleSelectAll = (table: any) => {
    const {
      options: { data: tableData },
    } = table;
    const isSelected = searchParams.get("selectAllItems");
    if (isSelected === "1") {
      searchParams.set("selectAllItems", "0");
      searchParams.delete("selectedItems");
      setSearchParms(searchParams);
    } else {
      const selectedItems = tableData
        ?.map((item: any) => item.id)
        .join(",")
        .toString();
      searchParams.set("selectAllItems", "1");
      searchParams.set("selectedItems", selectedItems);
      setSearchParms(searchParams);
    }
  };

  const defaultColumns: any = [
    {
      id: "select",
      header: ({ table }: any) => {
        return (
          <input
            type="checkbox"
            checked={checkedAllItems}
            onChange={() => handleSelectAll(table)}
            className={tw`cursor-pointer`}
          />
        );
      },
      cell: ({ row }: any) => (
        <input
          type="checkbox"
          checked={isSelected(row?.original?.id)}
          onChange={() => handleIndividualSelect(row?.original?.id)}
          className={tw`cursor-pointer`}
        />
      ),
    },
    {
      header: "Manifest ID",
      accessorKey: "tracking_number",
      cell: NACell,
    },
    {
      header: "Created",
      accessorKey: "created",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>
              {getValue()
                ? moment(getValue()).format("YY-MM-DD HH:mm:ss")
                : "N/A"}
            </p>
          </>
        );
      },
    },
    {
      header: "Updated",
      accessorKey: "modified",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>
              {getValue()
                ? moment(getValue()).format("YY-MM-DD HH:mm:ss")
                : "N/A"}
            </p>
          </>
        );
      },
    },
    {
      header: "Origin",
      accessorKey: "origin.name",
      cell: NACell,
    },
    {
      header: "D. Branch",
      accessorKey: "destination_branch.name",
      cell: NACell,
    },
    {
      header: "Total Items",
      accessorKey: "items.total",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
    {
      header: "Received Items",
      accessorKey: "items.received",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
    {
      header: "Missing Items",
      accessorKey: "items.missing",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
  ];
  let OrderColumns: any = [
    {
      id: "select",
      header: ({ table }: any) => {
        return (
          <input
            type="checkbox"
            checked={checkedAllItems}
            onChange={() => handleSelectAll(table)}
            className={tw`cursor-pointer`}
          />
        );
      },
      cell: ({ row }: any) => (
        <input
          type="checkbox"
          checked={isSelected(row?.original?.id)}
          onChange={() => handleIndividualSelect(row?.original?.id)}
          className={tw`cursor-pointer`}
        />
      ),
    },
    {
      header: "WayBill",
      accessorKey: "tracking_number",
      cell: ({ row, getValue }: any) => {
        return (
          <div className={tw`cursor-pointer`}>
            <p className={tw`whitespace-nowrap`}>{getValue() ?? "N/A"}</p>
          </div>
        );
      },
    },
    {
      header: "Date",
      accessorKey: "created",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            {getValue() ? (
              <p>{moment(getValue()).format("YY-MM-DD HH:mm:ss")}</p>
            ) : (
              "N/A"
            )}
          </>
        );
      },
    },
    {
      header: "Origin",
      accessorKey: "pickup_branch.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`uppercase`}>{getValue()}</p>
            <p className={tw`text-xs text-primary`}>
              {row?.original?.pickup_branch?.warehouse?.name}
            </p>
          </>
        );
      },
    },
    {
      header: "Sender",
      accessorKey: "sender.full_name",
      cell: NACell,
    },
    {
      header: "Receiver",
      accessorKey: "receiver.full_name",
      cell: NACell,
    },
    {
      header: "Destination",
      accessorKey: "destination.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`uppercase`}>{getValue()}</p>
            <p className={tw`text-xs text-primary`}>
              {row?.original?.destination_branch?.warehouse?.name}
            </p>
          </>
        );
      },
    },

    {
      header: "Piece",
      accessorKey: "piece",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`cursor-pointer`}>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
    {
      header: "Status",
      accessorKey: "delivery_status.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p
              className={tw`uppercase px-1 text-center rounded-md`}
              style={{ background: row?.original?.delivery_status?.color }}
            >
              {getValue()}
            </p>
            <p className={tw`text-xs text-primary`}>
              {row?.original?.rider?.name}
            </p>
          </>
        );
      },
    },
  ];

  const handleDetailNavigate = (row: any) => {
    navigate(`edit/${row?.original?.id}`);
  };

  const handleOrderNavigate = (row: any) => {
    console.info(row);
  };

  const filterParams = watch();

  useEffect(() => {
    handleSetState({
      ...localState,
      ...filterParams,
    });
  }, [filterParams]); //eslint-disable-line

  const params = useCallback(() => {
    const newValue = {};
    for (const [key, value] of Object.entries(filterParams)) {
      if (value) {
        if (Array.isArray(value)) {
          newValue[key] = value.map((v) => v.value).join(",");
        } else if (typeof value === "object") {
          newValue[key] = value.id;
        } else if (!value) {
          newValue[key] = null;
        } else {
          newValue[key] = value;
        }
      }
    }
    return newValue;
  }, [filterParams]);

  return (
    <>
      <Card title="Filters" onClick={() => setFilterVisiable(!isFilterVisible)}>
        <ManifestFilter
          isFilterVisible={isFilterVisible}
          setValue={setValue}
          getValues={getValues}
          reset={handleFilterReset}
          control={control}
        />
      </Card>
      {active === "pending_order" ? (
        <DataTable
          key={"Order"}
          url={APIS.ORDER}
          queryKey={"orders"}
          handleDetailNavigate={handleOrderNavigate}
          tableName="pending-order"
          columns={OrderColumns}
          params={{
            is_final_status: true,
          }}
          addNewPagePath={"/create"}
          actionMenu={
            <>
              <div
                className={tw`w-full justify-end flex items-center gap-x-10 mx-2 `}
              >
                <button
                  type="button"
                  className={classNames(
                    active === "pending_order"
                      ? tw`bg-primary-active`
                      : tw`bg-primary-light`,
                    tw`px-4 py-2  text-primary rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`
                  )}
                  onClick={() => {
                    active === "pending_order"
                      ? setActive("")
                      : setActive("pending_order");
                  }}
                >
                  Consignment:{ConsignmentData?.count}
                </button>
              </div>
            </>
          }
        />
      ) : (
        <DataTable
          url={`${APIS.MANIFEST}dispatch-manifest`}
          key={"manifest"}
          queryKey={"manifest"}
          tableName="dispatch-manifest"
          params={{
            type: "dispatch",
            parent__isnull: true,
            ...params(),
          }}
          handleDetailNavigate={handleDetailNavigate}
          columns={defaultColumns}
          orderSearch={true}
          isDownload={true}
          actionMenu={
            <>
              <div
                className={tw`w-full justify-end flex items-center gap-x-10 mx-2`}
              >
                <button
                  className={classNames(
                    active === "pending_order"
                      ? tw`bg-primary-active`
                      : tw`bg-primary-light`,
                    tw`px-4 py-2  text-primary rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`
                  )}
                  onClick={() => {
                    active === "pending_order"
                      ? setActive("")
                      : setActive("pending_order");
                  }}
                >
                  Consignment:{ConsignmentData?.count}
                </button>
              </div>
            </>
          }
          addNewPagePath={"/create"}
        />
      )}
    </>
  );
};

export default ManifestList;
